import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNTreatmentLogo } from 'src/app/models/cntreatmentlogo';
import { ContactService } from 'src/app/services/contact.service';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-treatment-logo',
  templateUrl: './treatment-logo.component.html',
  styleUrls: ['./treatment-logo.component.scss']
})
export class TreatmentLogoComponent implements OnInit {

  @Input() contact: CNConsultation;
  @Output() applyGroup = new EventEmitter<string>();

  private theTreatment: CNTreatmentLogo;

  constructor(private services: ServicesService, private contactSrv: ContactService) { }

  ngOnInit(): void {
  }

  @Input() set treatment(treatment: CNTreatmentLogo) {
    this.theTreatment = treatment;
  }

  get treatment(): CNTreatmentLogo {
    return this.theTreatment;
  }

  increaseSession(event: any): void {
    this.theTreatment.sessionDone = event.target.value;
    if (this.contact) {
      // get rules
      const rule = this.services.contactCodeRule(this.contact.type);
      const group = rule.groupCodeForCount(this.theTreatment.sessionDone);
      if (group) {
        this.applyGroup.emit(group);
        this.contactSrv.applyContactGroup(group);
      }
    }
  }
}
